/**
 * @module productImageCarousel
 */
(function productImageCarousel() {

    function productImageCarousel ($dom) {
        /**
         * // local object availability
         * @type {productImageCarousel}
         * @private
         */
        var _this = this;

        /**
         * @type {element}
         */
        this.$carouselSlides = $dom.find('[data-hook-product-page-image-carousel="carousel-slides"]');

        /**
         * @type {element}
         */
        this.$carouselNavigation = $dom.find('[data-hook-product-page-image-carousel="image-navigation"]');

        /**
         * @method init
         * @returns {undefined}
         */
        this.init = function () {
            this.$carouselSlides.slick({
                    slidesToShow: 1,
                    slidesToScroll: 1,
                    arrows: true,
                    accessibility: false,
                    asNavFor: this.$carouselNavigation,  /* Syncing with {this.$carouselNavigation} */
                    dots: false,
                });

            this.$carouselNavigation.slick({
                    slidesToShow: 4,
                    slidesToScroll: 1,
                    arrows: true,
                    asNavFor: this.$carouselSlides, /* Syncing with {this.$carouselSlides} */
                    dots: false,
                    centerMode: false,
                    focusOnSelect: true,
            });
        };

        /**
         * initialize call
         */
        _this.init();
    };

    // define the global scope
    if (!window.Juzo) {
        window.Juzo = {};
    }

    window.Juzo.productImageCarousel = productImageCarousel;
})();



$(document).ready(function () {
    $productImageCarousel =  $('[data-hook-product-page-image-carousel="carousel"]');
    if ($productImageCarousel.length) {
        new window.Juzo.productImageCarousel($productImageCarousel);
    }
});